import { render, staticRenderFns } from "./PickUpDetails.vue?vue&type=template&id=6e0ffa4a&scoped=true"
import script from "./PickUpDetails.vue?vue&type=script&lang=js"
export * from "./PickUpDetails.vue?vue&type=script&lang=js"
import style0 from "./PickUpDetails.vue?vue&type=style&index=0&id=6e0ffa4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0ffa4a",
  null
  
)

export default component.exports